import { AfterContentInit, AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { GameProviderHttpService } from '@core/services/game-provider-http.service';
import { isLoggedIn } from '@core/store/auth/auth.selectors';
import { select, Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { Observable, of } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import svgIconList from 'assets/icons.json';
import { environment } from '@env/environment';

@Component({
  selector: 'app-game-menu',
  templateUrl: './game-menu.component.html',
  styleUrls: ['./game-menu.component.scss']
})
export class GameMenuComponent implements OnInit, AfterContentInit, AfterViewInit, OnChanges {
  svg: any = svgIconList;

  @Input() fixed: string;
  @Input() providers: any; // DI-SET dari parent (Home), JANGAN ditimpa localStorage
  @Input() gameCategoryCode: string;
  @Input() fromHome: string;
  @Input() gameCategoryName: string;

  countryCode = localStorage.getItem('country_code');
  languageCode = localStorage.getItem('language_code');

  activeProviderTab: string;
  tabCount = 0;
  tabWidth = '0 0 20%';

  isSlotsPage$ = this.gameProviderHttpService.isSlotsPage$;
  isDemo$ = this.gameProviderHttpService.isDemo$;
  activeType: string;
  isLoggedIn$: Observable<boolean>;
  slideDownDemo = false;
  gameProviderDemoMode = localStorage.getItem('gameProviderDemoMode');
  slotgameinit = true;

  // Mint Girl tab
  showMintGirl = false;

  audSite = ['QPRO18', 'QPRO19'];
  isAudSite = this.audSite.includes(environment.projectCode) ? true : false;

  get mintGirlIcon(): string {
    return this.svg?.mintGirlIcon;
  }

  constructor(
    private store: Store<AppState>,
    private eventEmitterService: EventEmitterService,
    private gameProviderHttpService: GameProviderHttpService,
    public dialog: MatDialog,
    private el: ElementRef,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.showMintGirl = this.isMintGirlBrand();

    this.slideDown(JSON.parse(localStorage.getItem('isDemoSelected')), false);
    this.isLoggedIn$ = this.store.pipe(select(isLoggedIn));
    this.isLoggedIn$.subscribe(res => {
      if (res) this.countryCode = localStorage.getItem('country_code');
    });

    this.activeProviderTab = this.gameCategoryCode ? this.gameCategoryName : null;

    // ⛔️ JANGAN override this.providers dari localStorage!
    // Kalau perlu refresh tab (mis. language/country berubah), cukup hitung ulang:
    this.eventEmitterService.topBarTabVar = this.eventEmitterService.topBarTabEmitter.subscribe(() => {
      this.recomputeTabs();
    });

    // Hitung awal
    this.recomputeTabs();

    this.eventEmitterService.demoSlideDownEmitter.subscribe(res => this.slideDown(res));
    this.eventEmitterService.getGameType = this.eventEmitterService.passGameType.subscribe(res => this.activeType = res);
    this.eventEmitterService.gameProviderDemoModeEmitter.subscribe(res => this.gameProviderDemoMode = res);

    if (localStorage.getItem('gameCategoryCode') != undefined && localStorage.getItem('gameCategoryName') != undefined) {
      this.slotgameinit = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['providers']) {
      this.recomputeTabs();
    }
  }

  ngAfterContentInit(): void {
    this.activeType = localStorage.getItem('activeType');
  }

  ngAfterViewInit(): void {
    this.setTab();
  }

  onSelectCategoryTab(gameCategoryCode: string, gameCategoryName: string) {
    this.eventEmitterService.onSlotsGamePage(false);
    localStorage.setItem('gameCategoryCode', gameCategoryCode);
    localStorage.setItem('gameCategoryName', gameCategoryName);
    this.eventEmitterService.onCasinoGamePage(false);

    // buang active class
    (this.el.nativeElement as HTMLElement).querySelectorAll('.oc-item').forEach(row => {
      row.classList.remove('active-category-tab');
    });

    this.activeProviderTab = gameCategoryName;
    this.eventEmitterService.onSelectProviderTabEmitter({ code: gameCategoryCode, name: gameCategoryName });

    if (gameCategoryCode === 'MG') {
      this.gameProviderHttpService.isSlotsPage$.next(false);
      this.gameProviderHttpService.toggleSlotsDemoStorage();
      return; // TIDAK routing
    }

    if (gameCategoryCode === 'SL' || gameCategoryCode === 'LC') {
      if (gameCategoryCode === 'SL') {
        this.gameProviderHttpService.isSlotsPage$.next(true);
        if (!this.slotgameinit && !this.fromHome) {
          this.eventEmitterService.onSlotsGamePage(true);
          this.router.navigateByUrl('/slots-game/');
        }
      } else {
        if (!this.slotgameinit && !this.fromHome) {
          this.eventEmitterService.onCasinoGamePage(true);
          this.router.navigateByUrl('/casino-game/');
        }
      }
    } else {
      this.gameProviderHttpService.isSlotsPage$.next(false);
    }
    this.gameProviderHttpService.toggleSlotsDemoStorage();
  }

  isBelongFromRoute(slug: string) {
    return (window.location.pathname).startsWith(`/${slug}`) || this.activeProviderTab === slug;
  }

  private slideDown(isDemo: boolean, onSwitch = true) {
    if (onSwitch) {
      of(null).pipe(delay(500), tap(() => { this.slideDownDemo = isDemo; })).subscribe();
    } else {
      this.slideDownDemo = isDemo;
    }
  }

  private setTab() {
    if (!this.tabCount || this.tabCount <= 0) return;
    const width = (100 / this.tabCount);
    this.tabWidth = `0 0 ${width}%`;
    const elements = document.querySelectorAll('.category-tabs');
    for (let i = 0; i < elements.length; i++) {
      // (elements[i] as HTMLElement).style.flex = this.tabWidth;
    }
  }

  private recomputeTabs() {
    this.tabCount = 0;
    const p = this.providers || {};
    Object.keys(p).forEach(key => {
      const arr = p[key];
      if (Array.isArray(arr) && arr.length > 0 && key !== 'CK') {
        this.tabCount++;
      }
    });
    if (this.showMintGirl) this.tabCount++;
    this.setTab();
  }

  private isMintGirlBrand(): boolean {
    const brand = (environment?.sitePrefix || '').toLowerCase();
    // display Mint Girl tab just for qpro9
    return brand === 'mint33' || brand === 'qpro9';
  }
}